module.exports = __webpack_public_path__ + "img/press_remind.2cc2d35d.png";